import './HighlightText.scss'

import React from 'react'

const highlight = (search = '', text = '') => {

    const index = text.toLowerCase().indexOf(search.toLowerCase())

    if (index < 0) {
      return [<span>{text}</span>] // eslint-disable-line react/jsx-key
    }

    const leading = <span>{text.slice(0, index)}</span>
    const match = <span className="highlighted">{text.slice(index, index + search.length)}</span>
    const remainder = highlight(search, text.slice(index + search.length))

    return [leading, match, ...remainder]
}

const HighlightText = ({ search, text }) => {
  if (!text || !search) {
    return <span>{text}</span>
  }
  return <div className="HighlightText">{highlight(search, text)}</div>
}

export default HighlightText
